import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
export class BsCustomDatesViewComponent {
}
BsCustomDatesViewComponent.decorators = [
    { type: Component, args: [{
                selector: 'bs-custom-date-view',
                template: `
    <div class="bs-datepicker-predefined-btns">
      <button *ngFor="let range of ranges">{{ range.label }}</button>
      <button *ngIf="isCustomRangeShown">Custom Range</button>
    </div>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush
            },] },
];
/** @nocollapse */
BsCustomDatesViewComponent.ctorParameters = () => [];
BsCustomDatesViewComponent.propDecorators = {
    'isCustomRangeShown': [{ type: Input },],
    'ranges': [{ type: Input },],
};
//# sourceMappingURL=bs-custom-dates-view.component.js.map